import { Component} from '@angular/core';

@Component({
    selector: 'honors-set-main',
    templateUrl: './honors-set-main.tmpl.html'
})

export class HonorsSetMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  